(() => {
  if (customElements.get('pn-editorial-rail')) return;
  const requests = new Map();
  const seasonal = /christmas|the-art-of-giving|advent|nutcracker/i;
  class PNCommerceRail extends HTMLElement {
    connectedCallback() {
      if (this.started) return;
      this.started = true;
      this.events = new AbortController();
      this.viewport = this.querySelector('.pn-commerce__viewport');
      this.button = this.querySelector('.pn-commerce__motion');
      this.desktop = matchMedia('(min-width: 750px) and (hover: hover) and (pointer: fine)');
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = false;
      this.visible = false;
      this.position = 0;
      this.dataset.loadState='loading';
      this.load();
    }
    async load() {
      try {
        const source = new URL(this.dataset.source, location.origin);
        if (source.origin !== location.origin || !/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?(?:collections|pages|blogs)\//i.test(source.pathname)) return;
        if (this.dataset.christmas !== 'true' && seasonal.test(source.href)) return;
        const shelf = decodeURIComponent(source.hash.slice(1));
        source.hash = '';
        if (this.dataset.previewTheme) source.searchParams.set('preview_theme_id', this.dataset.previewTheme);
        if (!requests.has(source.href)) requests.set(source.href, fetch(source.href, {credentials: 'same-origin'}).then(r => {
          if (!r.ok) throw new Error('Unavailable edit');
          return r.text();
        }));
        const doc = new DOMParser().parseFromString(await requests.get(source.href), 'text/html');
        if (!this.isConnected) return;
        const root = doc.querySelector('#MainContent');
        if (!root || (this.dataset.christmas !== 'true' && seasonal.test(root.querySelector('h1')?.textContent || ''))) return;
        let scope = root;
        if (shelf) {
          scope = doc.getElementById(shelf) || [...root.querySelectorAll('.tpe-shop-shelf[id]')].find(el => el.id.endsWith('-' + shelf));
          if (!scope) return;
        }
        const seen = new Set();
        let candidates=[...scope.querySelectorAll('.tpe-shop-card')];
        if(!candidates.length&&this.dataset.placement==='department'){
          const childSources=[...new Set([...scope.querySelectorAll('.tpe-shop-front__departments a[href]')].map(a=>{try{const u=new URL(a.getAttribute('href'),source);if(u.origin===source.origin&&u.pathname.endsWith('/collections/all')&&/^shop-/.test(u.searchParams.get('view')||''))return u.href;}catch{}return null;}).filter(Boolean))].slice(0,4);
          const children=await Promise.allSettled(childSources.map(async raw=>{const u=new URL(raw);if(this.dataset.previewTheme)u.searchParams.set('preview_theme_id',this.dataset.previewTheme);if(!requests.has(u.href))requests.set(u.href,fetch(u.href,{credentials:'same-origin'}).then(r=>{if(!r.ok)throw Error('Unavailable edit');return r.text();}));const child=new DOMParser().parseFromString(await requests.get(u.href),'text/html');return [...child.querySelectorAll('#MainContent .tpe-shop-card')].slice(0,4);}));
          const groups=children.filter(r=>r.status==='fulfilled').map(r=>r.value);
          candidates=[];for(let i=0;i<4;i++)for(const group of groups)if(group[i])candidates.push(group[i]);
        }
        const cards = candidates.filter(card => {
          if (card.matches('.tpe-shop-card--category,.tpe-shop-card--editorial')) return false;
          const link = card.querySelector('.tpe-shop-card__image[href]');
          const raw = link?.getAttribute('href')?.trim();
          if (!raw || raw === '#' || !card.querySelector('img[src]')) return false;
          let url;
          try { url = new URL(raw, source); } catch { return false; }
          if (!['https:', 'http:'].includes(url.protocol) || /(?:example\.(?:com|org)|localhost)/i.test(url.hostname)) return false;
          if (this.dataset.christmas !== 'true' && seasonal.test(url.href + ' ' + (card.querySelector('h3')?.textContent || ''))) return false;
          if (seen.has(url.href)) return false;
          seen.add(url.href);
          return true;
        }).slice(0, 12);
        if (!cards.length && (this.dataset.treatment !== 'feature' || !root.querySelector('h1') || /^(products|collections|page not found|404)$/i.test(root.querySelector('h1').textContent.trim()))) return;
        const editLink = new URL(this.dataset.source, location.origin);
        editLink.hash = shelf ? scope.id : '';
        this.querySelector('.pn-commerce__all').href = editLink.href;
        if (this.dataset.placement === 'article' && document.querySelector('pn-editorial-rail[data-placement="article"]') !== this) return;
        for (const card of cards) {
          card.querySelectorAll('script,style,iframe').forEach(el => el.remove());
          for (const el of [card, ...card.querySelectorAll('*')]) {
            el.removeAttribute('id');
            el.removeAttribute('data-shopify-editor-block');
            for (const a of [...el.attributes]) if (a.name.startsWith('on')) el.removeAttribute(a.name);
          }
          card.querySelectorAll('a[href]').forEach(a => { a.href = new URL(a.getAttribute('href'), source).href; });
          this.viewport.append(document.importNode(card, true));
        }
        this.querySelector('.pn-commerce__disclosure').hidden = this.dataset.treatment === 'feature' || !this.viewport.querySelector('a[rel~="sponsored"],a[data-pn-shopmy]');
        this.viewport.querySelectorAll('.pn-commerce-cta__arrow').forEach(el=>{el.innerHTML='<svg viewBox="0 0 12 12" aria-hidden="true"><path d="M2 10L10 2M2 2H10V10" fill="none" stroke="currentColor" stroke-width="1.1"/></svg>';});
        if (this.dataset.placement === 'department') this.refine();
        this.hidden = false;
        this.dataset.loadState='ready';
        this.bind();
        if (location.hash === '#' + this.id) this.scrollIntoView({block: 'start'});
      } catch {
        this.dataset.loadState='unavailable';
        this.hidden = true;
      }
    }
    refine() {
      this.viewport.querySelectorAll('.tpe-shop-card').forEach(card => {
        const copy=card.querySelector('.tpe-shop-card__copy'),media=card.querySelector('.tpe-shop-card__media'),link=card.querySelector('.tpe-shop-card__image[href]');
        if(!copy||!media||!link)return;
        const title=card.querySelector('h3')?.textContent.trim()||'';
        const brand=card.querySelector('.tpe-shop-card__brand,.tpe-shop-card__by')?.textContent.trim()||'';
        const overlay=document.createElement('div');overlay.className='pn-ec__rollover';
        const b=document.createElement('p');b.className='pn-ec__brand';b.textContent=brand;
        const h=document.createElement('h3');h.textContent=title;
        const note=document.createElement('p');note.textContent=Array.from(card.querySelectorAll('.tpe-shop-card__why p:not(.tpe-shop-card__why-heading):not(.pn-rationale-brand):not(.pn-rationale-title)')).map(e=>e.textContent.trim()).join(' ');
        overlay.append(b,h);if(note.textContent){const label=document.createElement('p');label.className='pn-ec__why-label';label.textContent='WHY IT MADE THE EDIT';overlay.append(label,note)}media.append(overlay);
        const details=document.createElement('details'),summary=document.createElement('summary');details.className='pn-ec__details';summary.textContent=this.dataset.detailsLabel;details.append(summary,overlay.cloneNode(true));card.append(details);
        const row=document.createElement('div'),save=document.createElement('button');row.className='pn-ec__bookmark-row';save.type='button';save.className='pn-ec__save';save.innerHTML='<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 4H19V21L12 17L5 21Z"/></svg>';
        const key='pn-wishlist-preview-v1';let items=[];try{const val=JSON.parse(localStorage.getItem(key)||'[]');items=Array.isArray(val)?val:[];}catch{}
        const sync=()=>{const yes=items.some(x=>x.url===link.href);save.setAttribute('aria-pressed',String(yes));save.setAttribute('aria-label',(yes?this.dataset.removeLabel:this.dataset.saveLabel)+' '+title);};sync();
        save.addEventListener('click',()=>{try{const val=JSON.parse(localStorage.getItem(key)||'[]');items=Array.isArray(val)?val:[];if(items.some(x=>x.url===link.href))items=items.filter(x=>x.url!==link.href);else items.push({url:link.href,title,brand,price:card.querySelector('.tpe-shop-card__price')?.textContent.trim()||'',image:card.querySelector('img')?.src||''});localStorage.setItem(key,JSON.stringify(items));sync();}catch{}});
        row.append(save);copy.prepend(row);
      });
    }
    bind() {
      const signal=this.events.signal;
      const listen=(target,type,fn,options={})=>target.addEventListener(type,fn,{...options,signal});
      listen(this.viewport,'pointerenter',()=>{this.hovered=true;this.sync();});
      listen(this.viewport,'pointerleave',()=>{this.hovered=false;this.sync();});
      listen(this.viewport,'focusin',()=>{this.focused=Array.from(this.viewport.querySelectorAll(':focus-visible')).length>0;this.sync();});
      listen(this.viewport,'focusout',()=>requestAnimationFrame(()=>{this.focused=Array.from(this.viewport.querySelectorAll(':focus-visible')).length>0;this.sync();}));
      listen(this.viewport,'pointerdown',()=>{this.dragging=true;this.sync();},{passive:true});
      listen(window,'pointerup',()=>{this.dragging=false;this.focused=false;this.sync();},{passive:true});
      const rest=()=>{clearTimeout(this.restTimer);this.interacting=true;this.sync();this.restTimer=setTimeout(()=>{this.interacting=false;this.sync();},1800);};
      listen(this.viewport,'wheel',e=>{if(Math.abs(e.deltaX)>Math.abs(e.deltaY)||e.shiftKey)rest();},{passive:true});
      listen(this.viewport,'keydown',e=>{
        if(['ArrowLeft','ArrowRight','Home','End'].includes(e.key))rest();
        if(e.target===this.viewport&&['ArrowLeft','ArrowRight'].includes(e.key)){e.preventDefault();this.viewport.scrollLeft+=(e.key==='ArrowRight'?1:-1)*(this.viewport.firstElementChild?.offsetWidth||240);}
      });
      listen(this.button,'click',()=>{this.paused=!this.paused;this.sync();});
      listen(document,'visibilitychange',()=>this.sync());
      listen(this.desktop,'change',()=>this.sync());listen(this.reduced,'change',()=>this.sync());
      this.visibility=new IntersectionObserver(entries=>{this.visible=entries[0].isIntersecting;this.sync();});this.visibility.observe(this);
      this.size=new ResizeObserver(()=>this.sync());this.size.observe(this.viewport);this.sync();
    }
    sync() {
      cancelAnimationFrame(this.frame);
      const available = this.dataset.treatment === 'moving' && this.desktop.matches && !this.reduced.matches && this.viewport.scrollWidth > this.viewport.clientWidth + 2;
      this.button.hidden = true;
      this.button.textContent = this.paused ? this.button.dataset.playLabel : this.button.dataset.pauseLabel;
      this.button.setAttribute('aria-pressed', String(this.paused));
      this.dataset.motion = available && !this.paused && !this.hovered && !this.focused && !this.dragging && !this.interacting && this.visible && !document.hidden ? 'running' : 'paused';
      if (this.dataset.motion !== 'running') return;
      this.position = this.viewport.scrollLeft;
      this.last = performance.now();
      this.frame = requestAnimationFrame(time => this.tick(time));
    }
    tick(time) {
      if (!this.isConnected || this.dataset.motion !== 'running') return;
      this.position += Math.min(time - this.last, 50) * .048;
      this.last = time;
      const first = this.viewport.firstElementChild;
      const distance = first.getBoundingClientRect().width + parseFloat(getComputedStyle(this.viewport).columnGap);
      if (this.position >= distance && this.viewport.scrollWidth - this.viewport.clientWidth > distance) {
        this.viewport.append(first);
        this.position -= distance;
      }
      if (this.position >= this.viewport.scrollWidth - this.viewport.clientWidth && this.viewport.scrollWidth - this.viewport.clientWidth <= distance) {
        this.paused = true;
        this.sync();
        return;
      }
      this.viewport.scrollLeft = this.position;
      this.frame = requestAnimationFrame(next => this.tick(next));
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      clearTimeout(this.restTimer);
      this.events?.abort();
      this.visibility?.disconnect();
      this.size?.disconnect();
      this.started = false;
    }
  }
  customElements.define('pn-editorial-rail', PNCommerceRail);
})();
